import { PublicContent } from './index';

export const contentZh: PublicContent = {
  nav: [
    { label: '首页', href: '/' },
    { label: '功能', href: '/features' },
    { label: '价格', href: '/pricing' },
    { label: '下载', href: '/download' },
    { label: '帮助', href: '/help' },
  ],
  footer: {
    product: [
      { label: '套餐价格', href: '/pricing' },
      { label: '功能特性', href: '/features' },
      { label: '客户端下载', href: '/download' },
    ],
    support: [
      { label: '帮助中心', href: '/help' },
      { label: '使用教程', href: '/help' },
      { label: '联系我们', href: '/about' },
    ],
    company: [
      { label: '关于我们', href: '/about' },
      { label: '隐私政策', href: '/privacy' },
      { label: '服务条款', href: '/terms' },
    ],
  },
  common: {
    login: '登录',
    register: '注册',
    getStarted: '立即开始',
    learnMore: '了解更多',
    relatedLinks: '相关链接',
    home: '首页',
    signInForLivePricing: '登录后可在控制台查看实时跨境网络套餐并完成购买。',
    contactSupport: '如需帮助，请通过在线客服或 Telegram 联系我们。',
  },
  landing: {
    heroTitle: '专业跨境网络服务',
    heroHighlight: '连接全球，助力出海业务',
    heroSubtitle:
      '一键连为跨境电商、TikTok 运营、海外 AI 工具（ChatGPT、Claude 等）及国际协作提供稳定可靠的全球业务网络。覆盖 Windows、macOS、Android 全平台 NodeUnion 官方客户端，让出海更高效。',
    featuresTitle: '为什么选择一键连',
    featuresSubtitle: '专注跨境业务场景，稳定可靠的全球业务网络服务',
    howItWorksTitle: '如何开始使用',
    howItWorksSubtitle: '简单三步，快速开启跨境网络服务',
    steps: [
      { title: '注册账户', description: '快速注册并验证邮箱，创建您的一键连账户。' },
      { title: '选择套餐', description: '根据业务流量与设备需求，选择适合的跨境网络套餐。' },
      { title: '下载客户端', description: '安装 NodeUnion 官方客户端，登录即可自动同步节点并开始使用。' },
    ],
    testimonialsTitle: '用户评价',
    testimonialsSubtitle: '来自跨境电商与出海从业者的真实反馈',
    testimonials: [
      { content: 'Shopify 后台和 PayPal 访问很稳定，日常运营不再担心网络中断。', author: '陈先生', role: '跨境电商卖家' },
      { content: 'TikTok 直播和发布都很流畅，东南亚和美国节点延迟低。', author: '林女士', role: 'TikTok 运营' },
      { content: '日常使用 ChatGPT 和 Claude 写文案、做分析，连接稳定不掉线。', author: '王先生', role: '出海创业者' },
    ],
    ctaTitle: '准备拓展您的全球业务？',
    ctaSubtitle: '立即注册，体验专业跨境网络服务',
    faqTitle: '常见问题',
    faqSubtitle: '关于一键连跨境网络服务的常见疑问',
    faqs: [
      {
        question: '一键连是什么？适合哪些业务场景？',
        answer:
          '一键连是专业的跨境网络服务，主要服务于跨境电商（Shopify、Amazon 等）、TikTok 运营、海外 AI 工具访问及国际远程协作。支持 Windows、macOS、Android 平台 NodeUnion 官方客户端。',
      },
      {
        question: '适合 TikTok 直播和运营吗？',
        answer:
          '我们提供覆盖美国、东南亚等 TikTok 热门地区的业务节点，优化直播推流、视频发布与后台管理体验。具体效果因网络环境而异，建议参考帮助中心选择合适节点。',
      },
      {
        question: '能否稳定使用 Shopify、Amazon 等跨境电商平台？',
        answer:
          '我们针对跨境电商场景优化节点线路，支持 Shopify 后台、Amazon Seller Central、PayPal 等常用平台访问。建议在业务低峰时段测试并选择延迟最低的节点。',
      },
      {
        question: '一个账户可以在几台设备上使用？',
        answer:
          '套餐通常支持多设备同时在线，具体数量以您购买的套餐说明为准。登录控制台可查看当前套餐的设备限制。',
      },
      {
        question: '是否记录用户浏览日志？',
        answer:
          '我们采用无日志政策，不记录用户的具体访问内容与浏览历史，仅保留必要的服务运行与计费数据。详见隐私政策。',
      },
      {
        question: '遇到问题如何获取技术支持？',
        answer:
          '您可以通过网站在线客服、提交工单或 Telegram 联系技术支持。帮助中心提供 NodeUnion 配置教程与业务场景指南。',
      },
    ],
    platformTitle: '全平台官方客户端',
    features: [
      { name: '安全可靠', description: '企业级加密协议，保护跨境业务数据传输安全' },
      { name: '全球节点', description: '覆盖美、日、东南亚等跨境电商与 TikTok 热门地区' },
      { name: '稳定低延迟', description: '智能路由优化，保障直播、AI 工具与电商后台流畅访问' },
      { name: '多端支持', description: 'Windows、macOS、Android NodeUnion 官方客户端' },
    ],
  },
  pricing: {
    title: '跨境网络套餐价格',
    subtitle: '灵活计费，满足不同出海业务场景。以下为参考价格，登录后可查看实时跨境网络套餐并完成购买。',
    plans: [
      {
        name: '基础版',
        price: '¥19',
        period: '/月',
        features: ['100GB 月流量', '2 台设备', '标准业务节点', '邮件支持'],
      },
      {
        name: '标准版',
        price: '¥39',
        period: '/月',
        features: ['300GB 月流量', '3 台设备', 'TikTok/跨境业务节点', '优先客服'],
        highlighted: true,
      },
      {
        name: '高级版',
        price: '¥69',
        period: '/月',
        features: ['不限流量', '5 台设备', '全部业务节点', '专属客服'],
      },
    ],
    comparisonTitle: '套餐功能对比',
    comparisonRows: [
      { feature: '月流量', basic: '100GB', standard: '300GB', premium: '不限' },
      { feature: '同时在线设备', basic: '2 台', standard: '3 台', premium: '5 台' },
      { feature: 'TikTok/跨境业务节点', basic: '—', standard: '✓', premium: '✓' },
      { feature: '海外 AI 工具线路', basic: '—', standard: '✓', premium: '✓' },
      { feature: '技术支持', basic: '邮件', standard: '优先', premium: '专属' },
    ],
    note: '以上价格为参考展示，实际价格以登录后订阅计划页面为准。季付、年付通常享有额外折扣。',
  },
  features: {
    title: '跨境网络功能特性',
    subtitle: '为跨境电商、TikTok 运营、海外 AI 工具与国际协作而设计，覆盖全球业务节点。',
    sections: [
      {
        title: '企业级安全加密',
        description:
          '采用 TLS 等主流安全协议，端到端加密传输，防止商业数据在传输过程中被窃听与篡改，保障公共网络下的业务安全。',
      },
      {
        title: '全球业务节点',
        description:
          '节点覆盖美国、日本、新加坡、香港、欧洲等跨境电商与 TikTok 热门地区，智能负载均衡确保低延迟与高可用。',
      },
      {
        title: 'TikTok 运营网络',
        description:
          '针对 TikTok 直播、视频发布、数据分析与后台管理优化线路，降低卡顿与断连，提升出海内容运营效率。',
      },
      {
        title: '海外 AI 工具访问',
        description:
          '优化 ChatGPT、Claude、Midjourney 等海外 AI 工具访问路径，降低超时与断连，适合内容创作、市场分析与产品开发。',
      },
      {
        title: '跨境电商支持',
        description:
          '稳定访问 Shopify、Amazon Seller Central、PayPal、eBay 等跨境电商平台，助力店铺管理与跨境收款。',
      },
      {
        title: '多设备与 7×24 支持',
        description:
          '一个账户支持手机、电脑等多台设备同时在线，提供在线客服、工单与 Telegram 支持，快速响应业务问题。',
      },
    ],
    scenarios: [
      { title: '跨境电商', description: '稳定管理 Shopify、Amazon 店铺，处理订单、物流与跨境支付。' },
      { title: 'TikTok 运营', description: '流畅完成 TikTok 直播、短视频发布与达人后台管理。' },
      { title: '海外 AI 工具', description: '高效使用 ChatGPT、Claude 等 AI 工具辅助内容创作与业务分析。' },
      { title: '国际远程办公', description: '稳定访问 Google Workspace、Slack、Zoom 等国际协作工具。' },
    ],
  },
  download: {
    title: 'NodeUnion 客户端下载',
    subtitle: '下载 NodeUnion 官方客户端，支持 Windows、macOS、Android 一键登录同步，快速开启跨境网络服务。',
    importTitle: '快速开始',
    importSteps: [],
    platforms: [
      { id: 'windows', name: 'Windows', description: 'Win 10/11 跨境业务 PC 客户端' },
      { id: 'macos', name: 'macOS', description: 'Apple Silicon Mac 跨境网络客户端' },
      { id: 'android', name: 'Android', description: '安卓手机 TikTok 移动运营客户端' },
      { id: 'ios', name: 'iOS', description: '登录用户中心查看 iOS 配置教程' },
    ],
  },
  help: {
    title: '跨境网络使用指南',
    subtitle: 'NodeUnion 客户端配置、TikTok 运营建议、海外 AI 工具访问与常见问题解答',
    faqs: [
      {
        question: '如何下载并安装 NodeUnion 客户端？',
        answer: '在「下载」页面选择对应平台，下载 NodeUnion 官方客户端并安装。Windows 和 Android 直接安装，macOS 需拖入应用程序文件夹。',
      },
      {
        question: '安装后如何登录并开始使用？',
        answer: '打开 NodeUnion，使用注册邮箱与密码登录。登录后自动同步节点，选择适合业务的节点并开启连接即可。Telegram 注册用户请参见仪表板说明。',
      },
      {
        question: 'TikTok 运营推荐使用哪些节点？',
        answer: '建议根据目标市场选择：美国市场选美国节点，东南亚市场选新加坡或香港节点。直播时优先选择延迟最低、负载较低的节点。',
      },
      {
        question: 'ChatGPT 等 AI 工具访问不稳定怎么办？',
        answer: '选择美国或新加坡低延迟节点，关闭浏览器其他代理插件，清除 Cookie 后重试。若仍超时，尝试切换节点或联系客服。',
      },
      {
        question: '跨境电商后台打不开怎么办？',
        answer: '确认套餐未到期，切换不同业务节点测试，清除浏览器缓存。Shopify/Amazon 建议使用 Chrome 无痕模式访问。',
      },
      {
        question: '如何续费套餐？',
        answer: '登录后进入「订阅计划」页面，选择套餐与周期完成支付。到期前建议提前续费避免业务中断。',
      },
      {
        question: '可以在多台设备上使用吗？',
        answer: '可以，具体设备数量取决于您的套餐。不使用的设备请及时断开连接，避免占用设备名额。',
      },
      {
        question: '忘记密码怎么办？',
        answer: '在登录页使用「忘记密码」功能，通过注册邮箱重置。若无法收到邮件，请联系客服协助处理。',
      },
    ],
    articles: [
      {
        id: 'nodeunion-windows',
        title: 'NodeUnion Windows 配置指南',
        category: '客户端配置',
        body: `## 下载安装\n\n1. 在下载页获取 NodeUnion Windows 安装包\n2. 双击运行安装程序，按提示完成安装\n\n## 登录使用\n\n1. 打开 NodeUnion 客户端\n2. 输入注册邮箱与密码登录\n3. 登录后自动同步节点列表\n4. 选择适合业务的节点（如美国节点用于 AI 工具）\n5. 点击连接，开始使用跨境网络服务\n\n## 常见问题\n\n- 安装被拦截：以管理员身份运行安装程序\n- 连接失败：检查套餐是否到期，切换节点重试`,
      },
      {
        id: 'nodeunion-macos',
        title: 'NodeUnion macOS 配置指南',
        category: '客户端配置',
        body: `## 下载安装\n\n1. 下载 NodeUnion macOS (.dmg) 安装包\n2. 打开 dmg，将应用拖入 Applications 文件夹\n\n## 解除隔离（如无法打开）\n\n在终端执行（仪表板可一键复制）：\n\`\`\`\nxattr -rd com.apple.quarantine /Applications/NodeUnion.app\n\`\`\`\n\n## 登录使用\n\n1. 打开 NodeUnion，使用邮箱密码登录\n2. 选择业务节点并连接\n3. 适合 Shopify 后台管理与 AI 工具日常使用`,
      },
      {
        id: 'nodeunion-android',
        title: 'NodeUnion Android 配置指南',
        category: '客户端配置',
        body: `## 下载安装\n\n1. 在下载页获取 NodeUnion Android APK\n2. 允许安装未知来源应用\n3. 安装并打开 NodeUnion\n\n## 登录使用\n\n1. 使用注册邮箱与密码登录\n2. 自动同步节点，选择并连接\n3. 适合 TikTok 移动端运营与外出办公\n\n## 提示\n\n- 允许网络连接权限\n- 关闭电池优化以保持后台连接稳定`,
      },
      {
        id: 'tiktok-operations',
        title: 'TikTok 运营网络使用建议',
        category: '业务场景',
        body: `## 节点选择\n\n- **美国市场**：选择美国节点，适合美区 TikTok 账号运营\n- **东南亚市场**：选择新加坡或香港节点\n- **直播场景**：优先低延迟节点，避免高峰时段\n\n## 使用建议\n\n1. 直播前提前测试节点延迟\n2. 发布视频时使用与账号地区匹配的节点\n3. 避免频繁切换节点，防止触发平台风控\n\n## 故障排查\n\n- 直播卡顿：切换低负载节点\n- 无法上传：检查网络连接，重启客户端\n- 后台异常：清除 App 缓存后重试`,
      },
      {
        id: 'overseas-ai-tools',
        title: '海外 AI 工具访问优化指南',
        category: '业务场景',
        body: `## 适用工具\n\nChatGPT、Claude、Gemini、Midjourney 等海外 AI 工具。\n\n## 推荐配置\n\n1. 选择美国或新加坡低延迟节点\n2. 使用 Chrome 浏览器，关闭其他代理插件\n3. 清除浏览器 Cookie 后重新访问\n\n## 常见问题\n\n- **Access denied**：切换节点或清除 Cookie\n- **响应超时**：检查本地网络，更换 DNS 为 8.8.8.8\n- **账号限制**：部分 AI 平台对账号地区有独立限制，与网络服务无关`,
      },
      {
        id: 'cross-border-ecommerce',
        title: '跨境电商常见网络问题',
        category: '业务场景',
        body: `## 支持平台\n\nShopify、Amazon Seller Central、PayPal、eBay、Stripe 等。\n\n## 使用建议\n\n1. 选择目标市场对应地区的业务节点\n2. 使用 Chrome 无痕模式访问后台\n3. 避免在支付环节频繁切换节点\n\n## 故障排查\n\n- 后台加载慢：切换低延迟节点\n- 登录异常：清除 Cookie，确认节点地区与店铺市场匹配\n- 支付失败：检查节点稳定性，避免支付过程中断连`,
      },
      {
        id: 'subscription-security',
        title: '账户与连接安全须知',
        category: '账户安全',
        body: `## 安全建议\n\n1. 使用强密码并定期更换\n2. 不要在公共设备保存登录信息\n3. 定期检查流量使用情况\n4. 发现异常登录及时修改密码\n\n## 套餐管理\n\n- 到期前 3 天建议续费\n- 升级套餐通常立即生效\n- 设备数量超出限制会导致新设备无法连接`,
      },
      {
        id: 'troubleshoot-connection',
        title: '连接故障排查手册',
        category: '故障排查',
        body: `## 无法连接\n\n1. 检查套餐是否到期\n2. 重启 NodeUnion 客户端\n3. 切换不同业务节点\n4. 检查本地防火墙/杀毒软件\n\n## 速度异常\n\n1. 选择延迟更低的节点\n2. 避免高峰时段进行大流量操作\n3. 关闭不必要的后台下载\n\n## 仍无法解决\n\n提交工单并附上：客户端版本、系统版本、错误截图、已尝试的步骤。`,
      },
      {
        id: 'renew-subscription',
        title: '套餐续费与升级指南',
        category: '账户管理',
        body: `## 续费\n\n1. 登录 → **订阅计划**\n2. 选择套餐与周期（月/季/年）\n3. 完成支付\n\n## 升级\n\n升级套餐通常立即生效，剩余时长按比例折算（以实际规则为准）。\n\n## 提醒\n\n建议在到期前 3 天续费，避免跨境业务中断。`,
      },
      {
        id: 'multi-device',
        title: '多设备使用说明',
        category: '账户管理',
        body: `## 设备限制\n\n不同套餐支持不同数量的同时在线设备，超出限制会导致新设备无法连接。\n\n## 管理建议\n\n1. 不使用的设备请及时断开连接\n2. 手机与电脑可各安装 NodeUnion 客户端\n3. 如需更多设备，请升级套餐\n\n## 团队使用\n\n企业用户可为不同岗位（运营、客服、管理）分配设备名额，避免超额。`,
      },
    ],
  },
  about: {
    title: '关于一键连',
    subtitle: '专注跨境网络服务，助力全球业务拓展',
    sections: [
      {
        title: '我们的使命',
        content:
          '一键连致力于为全球跨境电商卖家、TikTok 运营者与出海企业提供稳定可靠的跨境网络服务。我们相信高效的网络连接是出海成功的基石，持续优化节点质量，让 ChatGPT 等 AI 工具、Shopify 等电商平台的访问更简单、更稳定。',
      },
      {
        title: '服务承诺',
        content:
          '我们承诺 99.9% 以上的服务可用性目标，采用无日志政策保护用户隐私，7×24 小时响应技术支持。所有节点均经业务场景测试，定期维护升级，确保您的出海业务网络稳定可靠。',
      },
      {
        title: '联系我们',
        content:
          '如有任何问题或合作意向，请通过网站右下角在线客服、提交工单或 Telegram 机器人 @OneTapLinkBot 联系我们。团队将在 24 小时内回复。',
      },
    ],
  },
  privacy: {
    title: '隐私政策',
    sections: [
      {
        title: '信息收集',
        content:
          '我们收集注册时提供的邮箱、账户信息及必要支付记录。为提供服务，可能收集连接时间、流量使用量等运行数据，但不会记录具体浏览内容、访问 URL 或 DNS 查询详情。',
      },
      {
        title: '信息使用',
        content:
          '信息用于账户管理、计费、服务优化与技术支持。我们不会出售个人信息，仅在法律要求或保护合法权益所必需时披露。',
      },
      {
        title: '数据安全',
        content:
          '采用行业标准安全措施保护数据，包括传输加密、访问控制与安全审计。建议使用强密码，妥善保管账户信息。',
      },
      {
        title: '无日志政策',
        content:
          '实行无日志政策：不记录用户访问的网站、下载内容或通信详情，仅保留提供服务所必需的最少数据。',
      },
      {
        title: '政策更新',
        content:
          '我们可能不时更新本政策，重大变更将通过网站公告或邮件通知。继续使用服务即表示接受更新后的政策。',
      },
    ],
  },
  terms: {
    title: '服务条款',
    sections: [
      {
        title: '服务说明',
        content:
          '一键连提供跨境网络连接服务，主要面向跨境电商、TikTok 运营、海外 AI 工具访问及国际协作等合法商业用途。用户需确保在所在司法管辖区内使用本服务符合当地法律法规。',
      },
      {
        title: '账户规则',
        content:
          '用户应提供真实注册信息，妥善保管账户密码。禁止共享账户、转售服务或用于违法活动，包括网络攻击、垃圾邮件、侵犯版权等行为。',
      },
      {
        title: '付款与退款',
        content:
          '用户应按所选套餐支付费用。数字服务一经开通，原则上不支持退款。如因服务故障导致长时间无法使用，可联系客服申请酌情处理。',
      },
      {
        title: '使用限制',
        content:
          '用户不得利用本服务进行 DDoS 攻击、端口扫描、发送垃圾邮件或其他滥用行为。我们有权在发现违规时警告、限制或终止账户。',
      },
      {
        title: '免责声明',
        content:
          '本服务按「现状」提供。因用户配置错误、第三方平台政策变化或不可抗力导致的损失，我们不承担责任。',
      },
    ],
  },
  platforms: {
    windows: {
      id: 'windows',
      name: 'Windows',
      href: '/download/windows',
      clients: ['NodeUnion 官方客户端'],
      requirements: 'Windows 10 或 Windows 11，64 位系统',
      steps: [
        '下载并安装 NodeUnion 官方 Windows 客户端',
        '使用注册邮箱与密码登录（Telegram 用户见仪表板说明）',
        '选择适合业务的节点（如美国节点用于 AI 工具、东南亚节点用于 TikTok）',
        '点击连接，开始跨境网络服务',
      ],
      troubleshooting: [
        { issue: '安装被安全软件拦截', fix: '以管理员身份运行安装程序，临时关闭杀毒软件' },
        { issue: '节点全部超时', fix: '检查套餐是否到期，切换不同业务节点，检查防火墙设置' },
        { issue: 'Shopify 后台加载慢', fix: '切换目标市场对应的低延迟节点' },
      ],
    },
    macos: {
      id: 'macos',
      name: 'macOS',
      href: '/download/macos',
      clients: ['NodeUnion 官方客户端'],
      requirements: 'macOS 11 或更高版本，Apple Silicon (M 系列) 芯片',
      steps: [
        '下载 NodeUnion macOS 客户端 (.dmg) 并安装',
        '若无法打开，在终端执行 xattr 解除隔离（仪表板可一键复制命令）',
        '使用账户登录，自动同步节点',
        '选择业务节点并连接，开始跨境网络服务',
      ],
      troubleshooting: [
        { issue: '提示无法验证开发者', fix: '系统设置 → 隐私与安全性 → 允许打开' },
        { issue: 'AI 工具访问超时', fix: '切换美国或新加坡节点，清除浏览器 Cookie' },
        { issue: '连接后无法访问', fix: '重启客户端，切换低负载节点' },
      ],
    },
    android: {
      id: 'android',
      name: 'Android',
      href: '/download/android',
      clients: ['NodeUnion 官方客户端'],
      requirements: 'Android 7.0 或更高版本，ARM64 设备',
      steps: [
        '下载 NodeUnion Android APK 并允许安装未知来源应用',
        '安装后打开，使用注册邮箱与密码登录',
        '自动同步节点，选择适合 TikTok 运营或日常业务的节点',
        '点击连接，开始跨境网络服务',
      ],
      troubleshooting: [
        { issue: '网络连接权限被拒绝', fix: '在系统设置中清除应用数据后重新授权' },
        { issue: 'TikTok 上传失败', fix: '切换与账号地区匹配的节点，检查网络连接' },
        { issue: '后台断连', fix: '关闭电池优化，允许后台运行与自启动' },
      ],
    },
    ios: {
      id: 'ios',
      name: 'iOS',
      href: '/download/ios',
      clients: ['NodeUnion 官方客户端'],
      requirements: 'iOS 14 或更高版本，详细配置请登录用户中心查看',
      steps: [
        '注册并购买套餐',
        '登录用户中心查看 iOS 配置教程',
        '如有疑问请联系在线客服获取支持',
      ],
      troubleshooting: [
        { issue: '如何获取 iOS 配置？', fix: '登录后在「使用教程」或联系客服获取最新指南' },
        { issue: '连接不稳定', fix: '切换不同业务节点，检查本地网络环境' },
        { issue: '需要技术支持', fix: '通过工单或 Telegram 联系客服' },
      ],
    },
  },
};
